import { NgModule, Provider, forwardRef } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LoadingDirective } from './directives/loading.directive';
import { FocusOnClickDirective } from './directives/focus-on-click.directive';
import { NgMatTableQueryReflectorDirective } from './directives/ng-mat-table-query-reflector.directive';
import { FlexLayoutModule } from '@angular/flex-layout';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MAT_FORM_FIELD_DEFAULT_OPTIONS, MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { CookieModule } from 'ngx-cookie';
import { MatIconModule } from '@angular/material/icon';
import { MatCardModule } from '@angular/material/card';
import { NgxTranslateModule } from '../translate/translate.component';
import { MatSliderModule } from '@angular/material/slider';
import { MatSelectModule } from '@angular/material/select';
import { MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import {MatCheckboxModule} from '@angular/material/checkbox';
import {MatPaginatorModule} from '@angular/material/paginator';
import { MatTableExporterModule } from 'mat-table-exporter';
import { MatSortModule } from '@angular/material/sort';
import { RouterModule } from '@angular/router';
import { NgMultiSelectDropDownModule } from 'ng-multiselect-dropdown';
import {MatExpansionModule} from '@angular/material/expansion';
import { ListInputComponent } from './list-input/list-input.component';
import {MatChipsModule } from '@angular/material/chips';
import {MatAutocompleteModule} from '@angular/material/autocomplete';
import { TableSearchComponent } from './table-search/table-search.component';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { AreaGroupTypeDropdownComponent } from './area-group-type-dropdown/area-group-type-dropdown.component';

@NgModule({
  declarations: [
    LoadingDirective,
    FocusOnClickDirective,
    NgMatTableQueryReflectorDirective,
    ListInputComponent,
    TableSearchComponent,
    AreaGroupTypeDropdownComponent    
  ],
  imports: [
    CommonModule,
    MatInputModule,
    CookieModule.withOptions(),
    NgxTranslateModule,
    MatChipsModule,
    MatAutocompleteModule,
    MatIconModule,
    ReactiveFormsModule,
    NgMultiSelectDropDownModule
    
    ],
  providers: [
      MatFormFieldModule,
      {
          provide: MAT_FORM_FIELD_DEFAULT_OPTIONS,
          useValue: { appearance: 'fill'
          }
      }
  ],
  exports: [
    CommonModule,
    LoadingDirective,
    FocusOnClickDirective,
    NgMatTableQueryReflectorDirective,
    FlexLayoutModule,
    FormsModule,
    MatFormFieldModule,
    ReactiveFormsModule,
    MatInputModule,
    BrowserModule,
    BrowserAnimationsModule,
    CookieModule,
    MatIconModule,
    MatAutocompleteModule,
    MatCardModule,
    NgxTranslateModule,
    MatSliderModule,
    MatSelectModule,
    MatDialogModule,
    MatButtonModule,
    MatCheckboxModule,
    MatPaginatorModule,
    MatTableExporterModule,
    MatSortModule,
    MatPaginatorModule,
    RouterModule,
    NgMultiSelectDropDownModule,
    MatExpansionModule,
    ListInputComponent,
    TableSearchComponent,
    DragDropModule,
    AreaGroupTypeDropdownComponent
    
          
  ]

})
export class SharedModule { }
